import axios from 'axios';

const API_URL = 'https://api.coin.asynclabs.co/';

export default class RequestHelper {
  constructor () {
    this.apiUrl = process.env.API_URL;
  }

  getAPIUrl (route) {
    return API_URL + route;
  }

  /**
   * @param route
   * @param params
   * @returns {AxiosPromise<any>}
   */
  getAPICall (route, params) {
    return axios.get(this.getAPIUrl(route), params);
  }

  postAPICall (route, params) {
    return axios.post(this.getAPIUrl(route), params);
  }
}



// WEBPACK FOOTER //
// ./src/utils/RequestHelper.js